<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import { msalMixin } from 'vue-msal'

  export default {
    name: 'App',
    mixins: [msalMixin],
    mounted: function () {
      if (!this.msal.isAuthenticated) {
        this.$router.replace('AuthPage')
      }
    },
    data () {
      return {
        section: 'Head'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?beedc41a